import { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as styles from 'styles/molecules/forms/Form.css'
import { FORM_CREATE_INCOME_TRACKER, FORM_CREATE_SPENDING_TRACKER } from 'constants/forms'
import Button from 'components/features/pfm/Button/Button'
import { ReduxFormConfig, ReduxFormProps } from 'interfaces/component'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { formatPercent } from 'helpers/formatHelpers'
import { getSaveButtonFormProps, shouldAsyncValidate } from 'helpers/formHelpers'
import { FIELD_CURRENCY_WRAPPED_PROPS } from 'constants/fields'
import { asyncValidator } from 'helpers/schemaHelpers'
import trackerLimitFormSchema from 'schemas/trackerLimitFormSchema'

export type TrackerLimitFormValues = {
  category: string
  limit: number | null
  isNew: boolean
}

export type TrackerLimitFormProps = ReduxFormProps & {
  avgIncome: number
  formLimitValue: number
  limitLabel: string
  isMobile: boolean
}

type TrackerLimitFormState = {
  incomePercent: number
}

const calculateIncomePercent = (value: string | number | null, income: number) => {
  return Number(value) / income
}

class TrackerLimitForm extends Component<TrackerLimitFormProps, TrackerLimitFormState> {
  static getDerivedStateFromProps (nextProps: TrackerLimitFormProps) {
    const { formLimitValue, avgIncome } = nextProps
    const incomePercent = calculateIncomePercent(formLimitValue, avgIncome)
    return { incomePercent }
  }

  state = {
    incomePercent: 0,
  }

  render () {
    const { handleSubmit, avgIncome, formLimitValue, limitLabel, isMobile } = this.props
    const { incomePercent } = this.state

    const limitIncomePercentage = formLimitValue > 0 && avgIncome > 0 ? (
      <span className={ styles.fieldHint }>
        { formatPercent(incomePercent, 'one-if-ceiled') } of <br /> your income
      </span>
    ) : null

    const limitFieldProps = {
      autoComplete: 'off',
      autoFocus: !isMobile,
      label: `Your Monthly ${ limitLabel }`,
      type: 'tel',
      mask: createNumberMask({ prefix: '$' }),
      maxLength: 11,
    }

    return (
      <form onSubmit={ handleSubmit }>
        <div className={ styles.field }>
          <Field
            name='limit'
            component={ TextFieldWrapped }
            props={ limitFieldProps }
            { ...FIELD_CURRENCY_WRAPPED_PROPS }
          />
          { limitIncomePercentage }
        </div>
        <div className={ styles.submitButtonWrapperWide }>
          <Button
            { ...getSaveButtonFormProps(this.props) }
            size='tiny'
            submit
            fullWidth
          >
            Set { limitLabel }
          </Button>
        </div>
      </form>
    )
  }

  componentDidMount () {
    const { formLimitValue, avgIncome } = this.props
    const incomePercent = calculateIncomePercent(formLimitValue, avgIncome)
    this.updateIncomePercentage(incomePercent)
  }

  private updateIncomePercentage = (incomePercent: number) => {
    this.setState({ incomePercent })
  }
}

const commonFormProps: Partial<ReduxFormConfig> = {
  enableReinitialize: true,
  destroyOnUnmount: false,
  shouldAsyncValidate,
  asyncValidate: asyncValidator(trackerLimitFormSchema),
}

@reduxForm({ ...commonFormProps, form: FORM_CREATE_SPENDING_TRACKER })
export class SpendingTrackerLimitForm extends TrackerLimitForm {}

@reduxForm({ ...commonFormProps, form: FORM_CREATE_INCOME_TRACKER })
export class IncomeTrackerLimitForm extends TrackerLimitForm {}
